/**
 * One row of the resource usage report: a single UTC day of activity for one
 * organization on one tracked resource. Days without activity are not emitted.
 */
export interface IResourceAccessUsageReportRowSchema {
    /** UTC day, `YYYY-MM-DD`. */
    date: string;
    organizationId: string;
    resource: string;
    /** Requests served that day. */
    calls: number;
    /** Billable transactions, using the HERE Maps matrix charging rule. */
    transactions: number;
}
